import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityCardItem from '../cards/entity-card-item/entity-card-item.vue';

@Component({
  name: 'bpc-grid',
  components: {
    'bpc-entity-card-item': EntityCardItem,
  },
})
export default class Grid extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  @Prop(Array) readonly items: AnyEntity[];
  @Prop(String) readonly entity: string;
  @Prop(String) readonly cardComponent: string;
  @Prop(String) readonly type: string;
  @Prop({
    type: [Array, Object],
    default() {
      return [];
    },
  })
  readonly gridCols: string[] | object;

  onActionClicked(event, item) {
    this.$emit('action-clicked', event, { item: item });
  }

  get smCols() {
    return this.gridCols['sm'] ? this.gridCols['sm'] : '12';
  }

  get mdCols() {
    return this.gridCols['md'] ? this.gridCols['md'] : '4';
  }

  get lgCols() {
    return this.gridCols['lg'] ? this.gridCols['lg'] : '4';
  }
}
